"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.postMessageToVisitorWindow = void 0;
const postMessageToVisitorWindow = ({
  targetWindow,
  iframeSrc,
  type,
  data
}) => {
  if (targetWindow.closed) {
    return;
  }
  return targetWindow.postMessage(JSON.stringify({
    type,
    data
  }), iframeSrc);
};
exports.postMessageToVisitorWindow = postMessageToVisitorWindow;